import { COLORS } from '@btime/constants'
import { capitalizeIfLower, formatDate } from '@btime/helpers'
import { compose, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { SmallText, Title } from '../../../components/presentation/Text'
import { useChecklist } from './_load/ChecklistLoader'
import { useChecklistActionsList } from '../../../utils/actions/checklist/list'
import { useChecklistFastActionsList } from '../../../utils/actions/checklist/fastList'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import DeletedTag from '../../../components/helpers/DeletedTag'
import DropdownLink from '../../../components/navigation/DropdownLink'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Icon from '../../../components/shapes/Icon'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Separator from '../../../components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigation()
  const checklist = useChecklist()

  const [options] = useChecklistActionsList(checklist, null, { hide: ['seeDetails', 'clone'] })

  const title = compose(capitalizeIfLower, prop('name'))(checklist)
  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm'), prop('insertedAt'))(checklist)

  const fastActions = useChecklistFastActionsList(checklist)

  return (
    <Fragment>
      <FlexGrid justify="flex-start" gutter={0.3}>
        <FlexCol flex={1}>
          <Title size="h4" strong color={COLORS.dark2} noMargin>
            {title}
          </Title>
          <SmallText color={COLORS.dark3}>
            {t('createdAt')} {createdAt}
          </SmallText>
        </FlexCol>

        <FlexCol flex={1}></FlexCol>

        <FlexCol>
          <DeletedTag entity={checklist} />
        </FlexCol>
        <FlexCol>
          <RefetchingIndicator />
        </FlexCol>

        {!checklist.deleted && (
          <>
            {fastActions.map(action => (
              <>
                <FlexCol key={action.label}>
                  <IconText iconLeft={action.icon} color="dark3" bold {...action} noWrap />
                </FlexCol>
                <Separator vertical />
              </>
            ))}
            <FlexCol>
              <DropdownLink
                fromRight
                options={options}
                actionContent={<Icon name="BsThreeDotsVertical" ize="1.4rem" />}
                t={t}
              />
            </FlexCol>
          </>
        )}
      </FlexGrid>

      <Separator weight={6} />

      {/*		<TabsMenu t={t} />*/}
    </Fragment>
  )
}

export default ModalHeader
